import { IBase } from "src/app/core/models/base";

export interface IContact extends IBase{
    id: string;
    fullName?: string;
    companyName: string;
    firstName: string;
    lastName: string;
    title: string;
    salutation: number;
    isCompany: boolean;
    street: string;
    city: string;
    zip: string;
    country: string;
    phone: string;
    email: string;
    website: string;
    remarks: string;
    contactPerson: string;
    externalNumber: string;
}

export interface ICreateContactRequest {
    companyName: string;
    firstName: string;
    lastName: string;
    title: string;
    salutation: number;
    isCompany: boolean;
    street: string;
    city: string;
    zip: string;
    country: string;
    phone: string;
    email: string;
    website: string;
    remarks: string;
    contactPerson: string;
    externalNumber: string;
}

export interface IUpdateContactRequest {
    id: string;
}

export enum Salutations {
    none = 0,
    mister = 1,
    misses = 2,
    misterandmisses = 3
}